import { Button, Divider, Tag, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table/interface';
import { ReactElement } from 'react';
import { Download, QuestionCircle } from 'react-bootstrap-icons';

import { EmptyText } from '@/common/components';
import { getDateFactory } from '@/common/utils';

import { SiteArchiveUploadStatus, SiteArchivesListTableDataObj } from '@/modules/Sites';

export const columns = (): ColumnsType<SiteArchivesListTableDataObj> => {
  return [
    {
      title: 'Назва',
      dataIndex: 'name',
      key: 'name',
      render: (value: SiteArchivesListTableDataObj['name'], record) => (
        <>
          { value }
          <Button href={ record.downloadLink } type="link" icon={ <Download/> }/>
        </>
      )
    },
    {
      title: 'Розмір',
      dataIndex: 'size',
      key: 'size'
    },
    {
      title: 'Сторінок',
      dataIndex: 'pagesCount',
      key: 'pagesCount',
      render: (value: SiteArchivesListTableDataObj['pagesCount'], record) => (
        <>{ record.status === SiteArchiveUploadStatus.Success ? value : <EmptyText/> }</>
      )
    },
    {
      title: 'Файлів',
      dataIndex: 'filesCount',
      key: 'filesCount',
      render: (value: SiteArchivesListTableDataObj['filesCount'], record) => (
        <>{ record.status === SiteArchiveUploadStatus.Success ? value : <EmptyText/> }</>
      )
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (value: SiteArchivesListTableDataObj['status'], record): ReactElement => {
        let tag: ReactElement = <></>;

        if (value === SiteArchiveUploadStatus.Success) tag = <Tag color="success">Успішно</Tag>;
        if (value === SiteArchiveUploadStatus.Error)
          tag = (
            <Tag color="error">
              <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                <span>Помилка</span>
                <Divider type="vertical" style={{ top: 'unset' }}/>
                { !!record.errorMessage && (
                  <Tooltip title={ record.errorMessage }>
                    <QuestionCircle style={{ cursor: 'help' }}/>
                  </Tooltip>
                ) }
              </div>
            </Tag>
          );
        if (value === SiteArchiveUploadStatus.InProcess) tag = <Tag color="blue">В процесі</Tag>;
        if (value === SiteArchiveUploadStatus.Pending) tag = <Tag color="gold">Очікує</Tag>;

        return tag;
      }
    },
    {
      title: 'Додано',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value: SiteArchivesListTableDataObj['createdAt']) => getDateFactory(value, 'August 16, 2018 08:02', true)
    },
    {
      title: 'Опрацьовано',
      dataIndex: 'processedAt',
      key: 'processedAt',
      render: (value: SiteArchivesListTableDataObj['processedAt']) => (value ? getDateFactory(value, 'August 16, 2018 08:02', true) : <EmptyText/>)
    }
  ];
};
